/* ============================================================
   FLAMBE — comportements du theme
   Aucune dependance. Tout est delegue depuis le document.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.flambeRoutes || {};

  /* ---------- utilitaires ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var format = window.flambeMoneyFormat || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var withDot = amount;
    return format
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', withComma.split(',')[0])
      .replace('{{amount}}', withDot)
      .replace('{{amount_no_decimals}}', withDot.split('.')[0]);
  }

  /* ---------- tiroir panier ---------- */

  function openCart() {
    var d = $('#CartDrawer');
    var o = $('#DrawerOverlay');
    if (!d) { return; }
    d.classList.add('is-open');
    if (o) { o.classList.add('is-open'); }
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = $('.drawer__close', d);
    if (close) { close.focus(); }
  }

  function closeCart() {
    var d = $('#CartDrawer');
    var o = $('#DrawerOverlay');
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) { o.classList.remove('is-open'); }
    document.body.style.overflow = '';
  }

  function refreshCart() {
    var url = (routes.root || '/') + '?sections=cart-drawer';
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) { return; }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#CartDrawerSection');
        var current = $('#CartDrawerSection');
        if (fresh && current) {
          var wasOpen = $('#CartDrawer') && $('#CartDrawer').classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) { openCart(); }
        }
        return fetch((routes.cart || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) { return; }
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
        });
      });
  }

  function addToCart(formData, button) {
    if (button) { button.setAttribute('aria-disabled', 'true'); }
    return fetch((routes.cart_add || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          var note = button && button.closest('form') && $('[data-add-error]', button.closest('form'));
          if (note) { note.textContent = res.body.description || res.body.message || ''; note.hidden = false; }
          return;
        }
        return refreshCart().then(openCart);
      })
      .finally(function () { if (button) { button.removeAttribute('aria-disabled'); } });
  }

  function changeLine(key, quantity) {
    return fetch((routes.cart_change || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCart);
  }

  /* ---------- delegation globale ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;

    var openBtn = t.closest('[data-cart-open]');
    if (openBtn && $('#CartDrawer')) { e.preventDefault(); openCart(); return; }

    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var remove = t.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-line-remove'), 0); return; }

    var menuOpen = t.closest('[data-menu-open]');
    if (menuOpen) {
      e.preventDefault();
      var m = $('#MobileMenu');
      var ov = $('#DrawerOverlay');
      if (m) { m.classList.add('is-open'); }
      if (ov) { ov.classList.add('is-open'); }
      return;
    }
    if (t.closest('[data-menu-close]')) {
      e.preventDefault();
      var mm = $('#MobileMenu');
      if (mm) { mm.classList.remove('is-open'); }
      var ov2 = $('#DrawerOverlay');
      if (ov2 && !($('#CartDrawer') && $('#CartDrawer').classList.contains('is-open'))) { ov2.classList.remove('is-open'); }
      return;
    }

    var overlay = t.closest('#DrawerOverlay');
    if (overlay) {
      closeCart();
      var m2 = $('#MobileMenu');
      if (m2) { m2.classList.remove('is-open'); }
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.qty');
      var input = wrap && $('input', wrap);
      if (input) {
        var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
        input.value = Math.max(parseInt(input.min || 1, 10), next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var dot = t.closest('[data-slide-to]');
    if (dot) {
      var show = dot.closest('.slideshow');
      setSlide(show, parseInt(dot.getAttribute('data-slide-to'), 10));
      return;
    }

    var thumb = t.closest('[data-gallery-thumb]');
    if (thumb) {
      e.preventDefault();
      var gal = thumb.closest('.gallery');
      var main = $('[data-gallery-main]', gal);
      if (main) { main.src = thumb.getAttribute('data-src'); main.srcset = ''; main.alt = thumb.getAttribute('data-alt') || ''; }
      $$('[data-gallery-thumb]', gal).forEach(function (b) { b.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      var m = $('#MobileMenu');
      if (m) { m.classList.remove('is-open'); }
    }
  });

  /* ---------- formulaires d'ajout au panier ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-add-form]')) { return; }
    if (!$('#CartDrawer')) { return; }
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    addToCart(new FormData(form), btn);
  });

  document.addEventListener('change', function (e) {
    var line = e.target.closest('[data-line-qty]');
    if (line) { changeLine(line.getAttribute('data-line-qty'), parseInt(line.value, 10)); return; }

    var picker = e.target.closest('[data-variant-picker]');
    if (picker) { updateVariant(picker); return; }

    var sort = e.target.closest('[data-sort]');
    if (sort) { sort.form.submit(); return; }
  });

  /* ---------- selecteur de variantes ---------- */

  function updateVariant(picker) {
    var root = picker.closest('[data-product-root]');
    if (!root) { return; }
    var dataEl = $('[data-variants]', root);
    if (!dataEl) { return; }
    var variants = JSON.parse(dataEl.textContent);

    var chosen = $$('[data-variant-picker] input:checked', root).map(function (i) { return i.value; });
    var match = variants.find(function (v) {
      return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
    });

    var idInput = $('[data-variant-id]', root);
    var submit = $('[data-add-form] [type="submit"]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-price-compare]', root);

    if (!match) {
      if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = submit.getAttribute('data-unavailable-text') || ''; }
      return;
    }

    if (idInput) { idInput.value = match.id; }
    if (priceEl) { priceEl.textContent = money(match.price); }
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = money(match.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (submit) {
      if (match.available) {
        submit.removeAttribute('aria-disabled');
        submit.textContent = submit.getAttribute('data-default-text') || submit.textContent;
      } else {
        submit.setAttribute('aria-disabled', 'true');
        submit.textContent = submit.getAttribute('data-sold-out-text') || submit.textContent;
      }
    }

    if (match.featured_image) {
      var main = $('[data-gallery-main]', root);
      if (main) {
        main.src = match.featured_image.src;
        main.srcset = [500, 800, 1200, 1600].map(function (w) {
          return match.featured_image.src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
        }).join(', ');
      }
      var thumb = $('[data-gallery-thumb][data-media-id="' + match.featured_image.id + '"]', root);
      if (thumb) {
        $$('[data-gallery-thumb]', root).forEach(function (b) { b.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
    }

    if (history.replaceState && match.id) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());
    }

    var stock = $('[data-stock]', root);
    if (stock) {
      var label = $('[data-stock-label]', stock);
      if (match.available) { stock.removeAttribute('data-out'); } else { stock.setAttribute('data-out', ''); }
      if (label && submit) {
        label.textContent = match.available
          ? (label.getAttribute('data-in-text') || label.textContent)
          : (submit.getAttribute('data-sold-out-text') || label.textContent);
      }
    }

    var sPrice = document.querySelector('[data-sticky-price]');
    if (sPrice) { sPrice.textContent = money(match.price); }
    var sVariant = document.querySelector('[data-sticky-variant]');
    if (sVariant) { sVariant.textContent = match.title; }
    var sBtn = document.querySelector('[data-sticky-add]');
    if (sBtn && submit) {
      sBtn.textContent = submit.textContent;
      if (match.available) { sBtn.removeAttribute('aria-disabled'); } else { sBtn.setAttribute('aria-disabled', 'true'); }
    }

    $$('[data-variant-text]', root).forEach(function (el) {
      var key = el.getAttribute('data-variant-text');
      var val = match[key] || (match.options && match.options.join(' / '));
      if (val) { el.textContent = val; }
    });
  }

  /* ---------- diaporama ---------- */

  function setSlide(show, index) {
    if (!show) { return; }
    var slides = $$('.slide', show);
    var dots = $$('[data-slide-to]', show);
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    show.setAttribute('data-current', index);
  }

  function initSlideshows() {
    $$('.slideshow').forEach(function (show) {
      var slides = $$('.slide', show);
      if (slides.length < 2) { return; }
      var delay = parseInt(show.getAttribute('data-autorotate') || '0', 10);
      if (!delay) { return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      setInterval(function () {
        var current = parseInt(show.getAttribute('data-current') || '0', 10);
        setSlide(show, (current + 1) % slides.length);
      }, delay * 1000);
    });
  }

  /* ---------- recommandations produit ---------- */

  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.getAttribute('data-loaded')) { return; }
      var url = el.getAttribute('data-url');
      if (!url) { return; }
      el.setAttribute('data-loaded', '1');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-recommendations]');
          if (fresh) { el.innerHTML = fresh.innerHTML; }
        })
        .catch(function () {});
    });
  }

  /* ---------- barre d'achat collante ---------- */

  /* Position dans le document, insensible au defilement : getBoundingClientRect
     depend du viewport, offsetTop non. */
  function docOffsetBottom(el) {
    var y = el.offsetHeight;
    while (el) { y += el.offsetTop; el = el.offsetParent; }
    return y;
  }

  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var root = $('[data-product-root]');
    var anchor = root ? $('[data-add-form] [type="submit"]', root) : null;
    if (!bar || !anchor || bar._bound) { return; }
    bar._bound = true;

    var seuil = docOffsetBottom(anchor);
    var dernier = 0;

    function afficher(oui) {
      if (oui === bar._shown) { return; }
      bar._shown = oui;
      clearTimeout(bar._t);
      if (oui) {
        bar.hidden = false;
        bar._t = setTimeout(function () { bar.classList.add('is-in'); }, 20);
      } else {
        bar.classList.remove('is-in');
        bar._t = setTimeout(function () { bar.hidden = true; }, 220);
      }
    }

    function verifier() {
      afficher((window.pageYOffset || document.documentElement.scrollTop) > seuil - 40);
    }

    function surDefilement() {
      var t = +new Date();
      if (t - dernier < 60) { return; }
      dernier = t;
      verifier();
    }

    window.addEventListener('scroll', surDefilement, { passive: true });
    window.addEventListener('resize', function () { seuil = docOffsetBottom(anchor); verifier(); });
    bar._check = verifier;
    verifier();
  }

  /* ---------- init ---------- */

  /* ---------- bandeau videos ---------- */

  // Rien n'est telecharge avant que la carte n'approche de l'ecran : les
  // sources portent data-src et ne deviennent src qu'a ce moment-la. Six
  // clips de 30 Mo charges d'office rendraient la fiche produit inutilisable.
  function initUgc() {
    var sobre = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    $$('[data-ugc-card]').forEach(function (carte) {
      if (carte._ugc) { return; }
      carte._ugc = true;

      var video = $('[data-ugc-video]', carte);
      if (!video) { return; }

      function armer() {
        if (video._armee) { return; }
        video._armee = true;
        $$('source', video).forEach(function (s) {
          var u = s.getAttribute('data-src');
          if (u) { s.src = u; }
        });
        video.load();
      }

      var bouton = $('[data-ugc-sound]', carte);
      if (bouton) {
        bouton.addEventListener('click', function () {
          var couper = !video.muted;
          if (!couper) {
            // Une seule video sonore a la fois, sinon c'est une cacophonie.
            $$('[data-ugc-video]').forEach(function (autre) {
              if (autre !== video) {
                autre.muted = true;
                var b = $('[data-ugc-sound]', autre.closest('[data-ugc-card]'));
                if (b) { b.setAttribute('aria-pressed', 'false'); }
              }
            });
          }
          video.muted = couper;
          bouton.setAttribute('aria-pressed', couper ? 'false' : 'true');
          armer();
          if (!couper) { video.play().catch(function () {}); }
        });
      }

      if (!('IntersectionObserver' in window)) { armer(); return; }

      var vue = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) {
            armer();
            if (!sobre) { video.play().catch(function () {}); }
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.25 });

      vue.observe(carte);
    });
  }

  /* ---------- pastilles stories + visionneuse ---------- */

  // Les pastilles ne chargent qu'une image ; la video n'est demandee qu'a
  // l'ouverture. Six clips sous le prix, sinon, c'est la fiche produit qui
  // paie l'addition au premier affichage.
  function initStories() {
    var racine = $('[data-stories]');
    var vue = $('[data-viewer]');
    if (!racine || !vue || racine._lie) { return; }
    racine._lie = true;

    var pastilles = $$('[data-story]', racine);
    if (!pastilles.length) { return; }

    var video = $('[data-viewer-video]', vue);
    var barres = $('[data-viewer-bars]', vue);
    var etiquette = $('[data-viewer-label]', vue);
    var index = -1;
    var focusAvant = null;

    barres.innerHTML = pastilles.map(function () {
      return '<span class="viewer__bar"><i></i></span>';
    }).join('');
    var segments = $$('.viewer__bar', barres);

    function progresser() {
      if (index < 0 || !video.duration) { return; }
      var part = video.currentTime / video.duration;
      var i = segments[index].firstElementChild;
      if (i) { i.style.width = (part * 100).toFixed(2) + '%'; }
    }

    function montrer(n) {
      if (n < 0) { n = 0; }
      if (n >= pastilles.length) { fermer(); return; }
      index = n;
      segments.forEach(function (s, k) {
        s.classList.toggle('is-done', k < n);
        if (k !== n) { s.firstElementChild.style.width = k < n ? '100%' : '0'; }
        else { s.firstElementChild.style.width = '0'; }
      });
      var b = pastilles[n];
      etiquette.textContent = b.getAttribute('data-label') || '';
      video.src = b.getAttribute('data-src');
      video.muted = false;
      video.play().catch(function () {
        // Sans geste utilisateur prealable le navigateur refuse le son :
        // on retombe sur une lecture muette plutot que sur rien du tout.
        video.muted = true;
        video.play().catch(function () {});
      });
    }

    function ouvrir(n) {
      focusAvant = document.activeElement;
      vue.hidden = false;
      document.body.style.overflow = 'hidden';
      montrer(n);
      var f = $('[data-viewer-close]', vue);
      if (f) { f.focus(); }
    }

    function fermer() {
      vue.hidden = true;
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.body.style.overflow = '';
      index = -1;
      if (focusAvant && focusAvant.focus) { focusAvant.focus(); }
    }

    pastilles.forEach(function (b, n) {
      b.addEventListener('click', function () { ouvrir(n); });
    });

    video.addEventListener('timeupdate', progresser);
    video.addEventListener('ended', function () { montrer(index + 1); });

    var suivant = $('[data-viewer-next]', vue);
    var precedent = $('[data-viewer-prev]', vue);
    if (suivant) { suivant.addEventListener('click', function () { montrer(index + 1); }); }
    if (precedent) { precedent.addEventListener('click', function () { montrer(index - 1); }); }
    var croix = $('[data-viewer-close]', vue);
    if (croix) { croix.addEventListener('click', fermer); }

    vue.addEventListener('click', function (e) {
      if (e.target === vue) { fermer(); }
    });

    document.addEventListener('keydown', function (e) {
      if (vue.hidden) { return; }
      if (e.key === 'Escape') { fermer(); }
      else if (e.key === 'ArrowRight') { montrer(index + 1); }
      else if (e.key === 'ArrowLeft') { montrer(index - 1); }
    });
  }

  function init() {
    initSlideshows();
    initRecommendations();
    initStickyBuy();
    initUgc();
    initStories();
    $$('[data-product-root]').forEach(function (root) {
      var picker = $('[data-variant-picker]', root);
      if (picker) { updateVariant(picker); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.FLAMBE = { openCart: openCart, closeCart: closeCart, refreshCart: refreshCart };

})();
